import React, { useMemo, useState } from "react";
import { Card, Button, InputNumber, Spin } from "antd";

const TableQuizCard = ({
  category,
  questions = [],
  answers = {},
  setAnswers,
  submitQuiz,
  submitted,
  results = {},
  loading,
  fetchQuiz,
  firstInputRef,
}) => {
  const [timeLeft] = useState(20);
const [carryAnswers, setCarryAnswers] = useState({});
  const width = window.innerWidth;

  const columns =
    width < 576
      ? 1
      : width < 992
      ? 2
      : 3;

  const cardWidth =
    width < 576
      ? "100%"
      : width < 992
      ? "95%"
      : "800px";

  const cellSize =
    width < 576
      ? 32
      : width < 992
      ? 38
      : 42;

  const fontSize =
    width < 576
      ? 22
      : width < 992
      ? 28
      : 32;
const getAnswerDigits = (id, length = 3) => {
  const value = answers[id] || "";
  return String(value).padStart(length, " ").split("");
};
  const allAnswered = useMemo(
    () =>
      questions.every(
        (q) =>
          answers[q.id] !== undefined &&
          answers[q.id] !== null
      ),
    [questions, answers]
  );

  const getDigits = (num) =>
    String(num).padStart(3, " ").split("");

  const renderCell = (value, key) => (
    <div
      key={key}
      style={{
        width: cellSize,
        height: cellSize,
        border: "1px solid #d0d0d0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize,
        fontWeight: "bold",
        background: "#fff",
      }}
    >
      {value.trim()}
    </div>
  );

  return (
    <Card
      title={
        <div
          style={{
            textAlign: "center",
            fontSize: width < 576 ? 18 : 40,
            fontWeight: "bold",
            color: "#ff6b00",
          }}
        >
          {category === "multiplication"
            ? "🧠 Multiplication 🎉"
            : category === "division"
            ? "🧠 Division 🎉"
            : "🧠Addition & Subtraction🎉"}
        </div>
      }
      style={{
        width: cardWidth,
        margin: "10px auto",
        borderRadius: 25,
        overflow: "hidden",
        boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
      }}
      styles={{
        body: {
          background: "#fffdf5",
          padding: width < 576 ? 15 : 25,
        },
      }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                width < 576
                  ? "1fr"
                  : width < 992
                  ? "repeat(1,260px)"
                  : "repeat(2,260px)",
              justifyContent: "center",
              gap: 25,
            }}
          >
            {questions.map((q, idx) => {
              const isCorrect = submitted
                ? results[q.id]
                : null;

              const topDigits = getDigits(q.a);
              const bottomDigits = getDigits(q.b);

              return (

<div
  key={q.id}
  style={{
    background: "#f8fbff",
    border: "2px solid #74c0fc",
    borderRadius: 20,
    padding: 15,
    textAlign: "center",
    boxShadow: "0 6px 16px rgba(116,192,252,0.20)",
  }}
>
  <div
    style={{
      fontSize: 24,
      fontWeight: "bold",
      marginBottom: 10,
    }}
  >
   ( {idx + 1} )
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: `repeat(4, ${cellSize}px)`,
      justifyContent: "center",
    }}
  >
    {/* Carry Row */}
    <div />

    {[0, 1, 2].map((carryIndex) => (
      <input
        key={`carry-${carryIndex}`}
        maxLength={2}
        disabled={loading || submitted}
        value={
          carryAnswers[q.id]?.[carryIndex] || ""
        }
        onChange={(e) => {
          const digit = e.target.value.replace(
            /\D/g,
            ""
          );

          setCarryAnswers((prev) => ({
            ...prev,
            [q.id]: {
              ...(prev[q.id] || {}),
              [carryIndex]: digit,
            },
          }));
        }}
  style={{
  width: cellSize + 12,
  height: 30,
  textAlign: "center",
  fontSize: 18,
  fontWeight: "bold",
  border: "2px dashed #74c0fc",
  borderRadius: 4,
  background: "#fffef0",
}}
      />
    ))}

    {/* First Number */}
    <div />
    {topDigits.map((d, i) =>
      renderCell(d, `top-${i}`)
    )}

    {/* Second Number */}
    {renderCell(q.operator, "operator")}
    {bottomDigits.map((d, i) =>
      renderCell(d, `bottom-${i}`)
    )}
  </div>

  {/* Line */}
  <div
    style={{
      width: cellSize * 4,
      borderTop: "4px solid #333",
      margin: "5px auto 10px",
    }}
  />

  {/* Answer Row */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: `repeat(3, ${cellSize}px)`,
      justifyContent: "center",
      gap: 2,
      marginLeft:50
    }}
  >
    {[0, 1, 2].map((digitIndex) => {
      const value =
        answers[q.id]
          ?.toString()
          ?.padStart(3, " ")[digitIndex] || "";

      return (
        <input
          key={digitIndex}
          type="text"
          maxLength={1}
          disabled={loading || submitted}
          value={value.trim()}
          onChange={(e) => {
            const digit = e.target.value.replace(
              /\D/g,
              ""
            );

            const current = (
              answers[q.id]
                ?.toString()
                .padStart(3, " ") || "   "
            ).split("");

            current[digitIndex] = digit;

            const newValue = current
              .join("")
              .trim();

            setAnswers((prev) => ({
              ...prev,
              [q.id]: newValue,
            }));
          }}
          style={{
            width: cellSize,
            height: cellSize,
            textAlign: "center",
            fontSize,
            fontWeight: "bold",
            border:
              submitted &&
              results[q.id] === true
                ? "2px solid green"
                : submitted &&
                  results[q.id] === false
                ? "2px solid red"
                : "2px solid #1890ff",
            borderRadius: 6,
            background: "#fff",
          }}
        />
      );
    })}
  </div>
</div>

              );
            })}
          </div>

          <Button
            type="primary"
            block
            size="large"
            onClick={submitQuiz}
            disabled={
              !allAnswered ||
              loading ||
              submitted ||
              !timeLeft
            }
            style={{
              marginTop: 30,
              height: 55,
              fontSize: 22,
              fontWeight: "bold",
              borderRadius: 15,
            }}
          >
            🚀 Submit Quiz
          </Button>

          {submitted && (
            <Button
              block
              size="large"
              onClick={fetchQuiz}
              style={{
                marginTop: 15,
                height: 55,
                fontSize: 22,
                fontWeight: "bold",
                borderRadius: 15,
                background:
                  "linear-gradient(135deg,#ff9d2f,#ff6126)",
                color: "#fff",
                border: "none",
              }}
            >
              🔄 New Game
            </Button>
          )}
        </>
      )}
    </Card>
  );
};

export default TableQuizCard;